
import BCXFooter from '@/components/BCXFooter.vue';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';
import { shouldUsePublicLandingpage } from '@/utils/publicSite';
import {
  computed, defineComponent, provide, ref
} from 'vue';
import InviteCodePopup from '@/components/login-register/InviteCodePopup.vue';
import LPHeaderNav from '@/views/public/landingpage/components/LPHeaderNav.vue';
import { useRoute } from 'vue2-helpers/vue-router';

const usePublicLandingpage = shouldUsePublicLandingpage();

export default defineComponent({
  name: 'LandingpageLayout',
  components: {
    LPHeaderNav,
    InviteCodePopup,
    BCXFooter
  },
  setup() {
    const { locale } = useI18n();
    const { isLandingPageMobileWidth, isLandingPageTabletWidth } = useResponsiveness();
    const route = useRoute();

    const showInviteCodePopup = ref(false);
    const invitePopupType = ref('freelancer');
    const allowStickyMainContent = computed(() => route.path.startsWith('/pblog'));
    const homeRoute = computed(() => (usePublicLandingpage ? { name: 'index' } : { name: 'Landingpage' }));

    const toggleInviteCodePopup = (type: 'freelancer' | 'customer') => {
      invitePopupType.value = type;
      showInviteCodePopup.value = !showInviteCodePopup.value;
    };

    provide('toggleInviteCodePopup', toggleInviteCodePopup);

    return {
      locale,
      isLandingPageMobileWidth,
      isLandingPageTabletWidth,
      showInviteCodePopup,
      invitePopupType,
      allowStickyMainContent,
      homeRoute
    };
  }
});
